import { render, staticRenderFns } from "./io-field.component.vue?vue&type=template&id=0e1f21f9&"
import script from "./io-field.component.vue?vue&type=script&lang=ts&"
export * from "./io-field.component.vue?vue&type=script&lang=ts&"
import style0 from "./io-field.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports